// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__w4QLF","box":"WorkspacesBox_box__2P8uI","node":"WorkspacesBox_node__32Ftv"};